export const endpoints = {
  auth: {
    saveUserData: "/auth/save-user-data",
  },
  session: {
    get: "/myProfile",
  },
  public: {
    courses: "/public/courses",
    course: (id: string) => `/public/course/${id}`,
  },
  payments: {
    createSubscription: "/payments/create-subscription",
    verifySubsription: "/payments/verify-subscription",
    cancelSubscription: "/payments/cancel-subscription",
    subscription: "./payments/subscription",
  },
  content: {
    list: "/content",
    create: "/content",
    get: (id: string) => `/content/${id}`,
    update: (id: string) => `/content/${id}`,
    delete: (id: string) => `/content/${id}`,
    generateLesson: `/content/generateLesson`,
    alternateContent: "/content/alternateContent",
    regenerateContent: "/content/regenerate",
    saveLesson: "/content/saveLesson",
    savePractice: "/content/savePractice",
    deleteLesson: (id: string) => `/content/lesson/${id}`,
    deletePractice: (id: string) => `/content/practice/${id}`,
    publishPractice: "/content/publishPractice",
    publishLesson: "/content/publishLesson",
    getTools: "/content/tools",
    codeExecute: "/content/codeExecution",
    chatbot: "/content/chatbot",
  },
  course: {
    list: "/course/list",
    create: "/course/create",
    get: (id: string) => `/course/${id}`,
    put: (id: string) => `/course/${id}`,
    delete: (id: string) => `/course/${id}`,
    publish: (id: string) => `/course/${id}/publish`,
    clearChanges: (id: string) => `/course/${id}/clear-changes`,
    uploadMedia: "/course/media/upload",
    removeMedia: "/course/media/remove",
  },
  module: {
    list: "/module/list",
    delete: (id: string) => `/module/${id}`,
    create: `/module`,
    get: (id: string) => `/module/${id}`,
    update: (id: string) => `/module/${id}`,
    consume: (id: string) => `/module/consume/${id}`,
  },
  users: {
    list: "/user",
    get: (id: string) => `/user/${id}`,
    edit: (id: string) => `/user/edit/${id}`,
    create: "/user/create",
    profile: "/user/profile",
    updateProfile: "/user/update/profile",
    info: "/user/info",
    requestEarlyAccess: "/user/request-access",
  },
  league: {
    list: "/league",
    create: "/league",
    get: (id: string) => `/league/${id}`,
    update: (id: string) => `/league/${id}`,
    delete: (id: string) => `/league/${id}`,
  },
  progress: {
    courses: "/progress/courses",
    course: (id: string) => `/progress/course/${id}`,
    addProgress: "/progress/add",
    reset: "/progress/reset-module",
  },
};
